import React from 'react';
import './styles.css';
import useVideoContext from '../../hooks/useVideoContext';
import useIsTrackEnabled from '../../hooks/useIsTrackEnabled';
import useAudioVolume from '../../hooks/useAudioVolume';
import ProfileAvatar from "../ProfileAvatar";
export default function LocalParticipantInfo(_ref) {
  var children = _ref.children,
      videoProcessor = _ref.videoProcessor;

  var _useVideoContext = useVideoContext(),
      localTracks = _useVideoContext.localTracks,
      localParticipant = _useVideoContext.room.localParticipant,
      onSpeakerEvent = _useVideoContext.onSpeakerEvent,
      participantsInfo = _useVideoContext.participantsInfo;

  var audioTrack = localTracks.find(function (track) {
    return track.kind === 'audio';
  });
  var videoIsMuted = !localTracks.find(function (track) {
    return track.kind === 'video';
  }); //const isAudioEnabled = useIsTrackEnabled(audioTrack);
  // const videoTrack = localTracks.find((track) => track.name.includes('camera'));
  //const isVideoEnabled = useIsTrackEnabled(videoTrack);

  var onVolumeChange = function onVolumeChange(volumeAvg, volumeMax) {
    onSpeakerEvent && onSpeakerEvent({
      event: 'volume',
      value: volumeMax,
      participantSid: localParticipant.sid,
      participantIdentity: localParticipant.identity,
      isLocal: true
    });
  }; // this hook will trakc local participants audio levels


  useAudioVolume(audioTrack, localParticipant, onVolumeChange);
  return /*#__PURE__*/React.createElement("div", {
    id: "LocalParticipantInfo.container",
    className: "local-participant-info__container " + (videoIsMuted ? 'local-participant-info--muted' : '')
  }, children, videoProcessor !== null && videoProcessor.enabled && videoProcessor.control && videoProcessor.control, videoIsMuted && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ProfileAvatar, {
    initials: participantsInfo.localInitials,
    avatar: participantsInfo.localAvatar,
    size: 70,
    fontSize: 28
  })));
}